import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [
    "phoneStep",
    "verifyStep",
    "phoneInput",
    "sendButton",
    "displayPhone",
    "consentCheckbox"
  ]

  static values = {
    redirectPath: String,
    onboarding: Boolean
  }

  get csrfToken() {
    return document.querySelector('meta[name="csrf-token"]').getAttribute("content")
  }

  connect() {
    this.validatePhone()

    if (this.hasVerifyStepTarget && !this.verifyStepTarget.classList.contains("tw-hidden")) {
      this.displayPhoneTarget.textContent = " " + this.phoneInputTarget.value
      const firstDigit = this.verifyStepTarget.querySelector('[data-otp-input-target="box"]')
      if (firstDigit) firstDigit.focus()
    }
  }

  validatePhone() {
    const phone = this.phoneInputTarget.value
    const digits = phone.replace(/\D/g, "").replace(/^1/, "")
    const isComplete = digits.length === 10
    const isValid = isComplete && /^[2-9]\d{9}$/.test(digits)

    const errorEl = document.getElementById("phone-validation-error")
    if (isComplete && !isValid) {
      errorEl.classList.remove("tw-hidden")
    } else {
      errorEl.classList.add("tw-hidden")
    }

    this.sendButtonTarget.disabled = !isValid
  }

  sendCode() {
    const btn = this.sendButtonTarget
    btn.disabled = true
    btn.classList.add("tw-opacity-50")

    const phone = this.phoneInputTarget.value

    fetch("/phone_verifications", {
      method: "POST",
      headers: {
        "X-CSRF-Token": this.csrfToken,
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({ profile: { phone: phone } })
    })
      .then(response => response.json().then(data => ({ ok: response.ok, data })))
      .then(({ ok, data }) => {
        if (ok) {
          this.displayPhoneTarget.textContent = " " + phone
          this.phoneStepTarget.classList.add("tw-hidden")
          this.verifyStepTarget.classList.remove("tw-hidden")

          const firstDigit = document.querySelector('[data-otp-input-target="box"]')
          if (firstDigit) firstDigit.focus()
        } else {
          this.showErrorToast(data.error)
          btn.disabled = false
          btn.classList.remove("tw-opacity-50")
        }
      })
      .catch(() => {
        btn.disabled = false
        btn.classList.remove("tw-opacity-50")
      })
  }

  checkCode() {
    const btn = document.getElementById("check_code_btn")
    if (btn) btn.disabled = true

    const hiddenField = document.querySelector('[data-otp-input-target="hidden"]')
    const code = hiddenField ? hiddenField.value : ""

    const smsConsent = this.hasConsentCheckboxTarget
      ? this.consentCheckboxTarget.checked
      : true

    fetch("/phone_verifications", {
      method: "PUT",
      headers: {
        "X-CSRF-Token": this.csrfToken,
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({ profile: { verification_code: code, sms_consent: smsConsent } })
    })
      .then(response => response.json().then(data => ({ ok: response.ok, data })))
      .then(({ ok, data }) => {
        if (ok) {
          if (this.redirectPathValue) {
            Turbo.visit(this.redirectPathValue)
          } else {
            Turbo.visit("/dashboard")
          }
        } else {
          if (btn) btn.disabled = false
          this.showErrorToast(data.error)
        }
      })
      .catch(() => {
        if (btn) btn.disabled = false
      })
  }

  resendCode() {
    const phone = this.phoneInputTarget.value
    if (!phone) return

    fetch("/phone_verifications", {
      method: "POST",
      headers: {
        "X-CSRF-Token": this.csrfToken,
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({ profile: { phone: phone } })
    })
      .then(response => {
        if (response.ok) {
          this.showResendToast("success", phone)
        } else {
          this.showResendToast("error")
        }
      })
      .catch(() => this.showResendToast("error"))
  }

  showResendToast(variant, phone = "") {
    const container = document.getElementById("onboarding-toast-container")
    const template = document.getElementById(`resend-toast-${variant}-template`)
    if (!container || !template) return

    const markup = variant === "success"
      ? template.innerHTML.replace(/__PHONE__/g, phone)
      : template.innerHTML

    container.innerHTML = markup
  }

  showErrorToast(message) {
    const container = document.getElementById("onboarding-toast-container")
    const template = document.getElementById("error-toast-template")
    if (!container || !template) return

    container.innerHTML = template.innerHTML.replace(/__MESSAGE__/g, message || "")
  }

  goBackToPhone() {
    this.verifyStepTarget.classList.add("tw-hidden")
    this.phoneStepTarget.classList.remove("tw-hidden")
    this.sendButtonTarget.disabled = false
    this.sendButtonTarget.classList.remove("tw-opacity-50")
    this.phoneInputTarget.focus()
  }
}
